export default __webpack_public_path__ + "static/media/photo--lg--10.40b92243.jpg";